function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function NavigationLinks(_ref) {
  var query = _ref.query,
    _ref$approximate = _ref.approximate,
    approximate = _ref$approximate === void 0 ? false : _ref$approximate,
    _ref$showTravelMode = _ref.showTravelMode,
    showTravelMode = _ref$showTravelMode === void 0 ? true : _ref$showTravelMode;
  var _useState = useState('driving'),
    _useState2 = _slicedToArray(_useState, 2),
    mode = _useState2[0],
    setMode = _useState2[1];
  var params = new URLSearchParams({
    api: '1',
    destination: query,
    travelmode: mode,
    dir_action: 'navigate'
  });
  return /*#__PURE__*/_jsxs("div", {
    className: "d-flex flex-wrap gap-2 align-items-center",
    children: [showTravelMode && /*#__PURE__*/_jsxs("label", {
      className: "small",
      children: ["Travel mode ", /*#__PURE__*/_jsxs("select", {
        className: "form-select form-select-sm",
        value: mode,
        onChange: e => setMode(e.target.value),
        children: [/*#__PURE__*/_jsx("option", {
          value: "driving",
          children: "Drive"
        }), /*#__PURE__*/_jsx("option", {
          value: "walking",
          children: "Walk"
        }), /*#__PURE__*/_jsx("option", {
          value: "bicycling",
          children: "Cycle"
        }), /*#__PURE__*/_jsx("option", {
          value: "transit",
          children: "Public transport"
        })]
      })]
    }), /*#__PURE__*/_jsx("a", {
      className: "btn btn-outline-primary btn-sm",
      href: "https://www.google.com/maps/dir/?".concat(params),
      target: "_blank",
      rel: "noreferrer",
      children: approximate ? 'Navigate to approximate area' : 'Navigate from my location'
    })]
  });
}